export default __webpack_public_path__ + "static/media/playlist-icon-related.d5cac45c.svg";